import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { ExpressionsApi, PatientCommonExpression } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';


export default /*@__PURE__*/_defineComponent({
  __name: 'editExpression',
  props: {
  expression: {
    type: Object,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const expressionsApi = new ExpressionsApi(medServerApiConfig);
const currentEntryStore = useCurrentEntryStore()

const props = __props

const emits = __emit
const focusRef= ref(null)

let doUpdate = true
const newOriginalText = ref(props.expression.originalText)

async function editExpression() {
  if (!doUpdate) return;
  if (!currentEntryStore.isEditable) return;
  const entryId = currentEntryStore.currentEntryId;
  const conceptExprId = props.expression.expressionId;
  const dbText = props.expression.originalText;
  const newText = newOriginalText.value;
  emits('close');
  if (newText !== dbText) {
    doUpdate = false;
    const updatedExpr: PatientCommonExpression = await expressionsApi.correctExpression({
      id: conceptExprId,
      expressionCorrectionRequest: {
        newValue: newText,
        patientEntryUuid: entryId
      }
    });
    currentEntryStore.updateExpressionAfterCorrection(updatedExpr, newText);
    currentEntryStore.reloadCurrentEntry();
    currentEntryStore.setReloadSummaryData(true);
    currentEntryStore.setReloadTreatmentData(true);
  }
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"35rem"},
    class: "bg-modal",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.expressionMoreMenu.correct'),
        styles: "font-l main-h",
        class: "mleft-04"
      }, null, 8, ["txt"]),
      _createVNode(_component_button_group, {
        class: "mleft-auto psides-10",
        styles: "border-h pad-s",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (editExpression()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _unref(t)('action.validate'),
            styles: "font-mBold"
          }, null, 8, ["txt"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_inputComboBox2, {
      ref_key: "focusRef",
      ref: focusRef,
      modelValue: newOriginalText.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newOriginalText).value = $event)),
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (editExpression()), ["enter"])),
      hasDropd: false,
      hasClearBtn: false,
      class: "mtop-10",
      style: {"width":"100%"}
    }, null, 8, ["modelValue"])
  ]))
}
}

})